import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Hero } from '@/components/home/hero'
import { AboutBand } from '@/components/home/about-band'
import { SelectedWork } from '@/components/home/selected-work'
import { Services } from '@/components/home/services'
import { ExploreBand } from '@/components/home/explore-band'
import { Testimonials } from '@/components/home/testimonials'
import { Journal } from '@/components/home/journal'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <Hero />
            <AboutBand />
            <SelectedWork />
            <Services />
            <ExploreBand />
            <Testimonials />
            <Journal />
        </Layout>
    )
}

export default Home
